import { AddAPhotoOutlined, Cancel, Done } from "@mui/icons-material";
import { Button } from "@mui/material";
import { type ContentWrapperProps } from "@src/components/ContentWrapper";
import { type AnyObject, type FormApi, type SubmissionErrors } from "final-form";
import { type FC, type PropsWithChildren } from "react";
import { type FormProps, useFormState } from "react-final-form";
import { FormattedMessage } from "react-intl";

import Form from "../../Form";
// eslint-disable-next-line @comet/no-private-sibling-import
import { FormButtonsWrapper } from "../Dialog.sc";

interface FormButtonsProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleCancelClick: (val: any) => void;
    handleSubmitClick: () => void;
    data: boolean;
}

const FormButtons: FC<PropsWithChildren<FormButtonsProps>> = ({ handleCancelClick, handleSubmitClick, data }) => {
    const { pristine, hasValidationErrors, submitting } = useFormState();

    return (
        <FormButtonsWrapper>
            <Button startIcon={<Cancel />} variant="text" onClick={handleCancelClick}>
                <FormattedMessage id="reviermanager.button.cancel" defaultMessage="Abbrechen" />
            </Button>
            {data ? (
                <Button type="submit" color="primary" variant="contained" startIcon={<Done />} onClick={handleSubmitClick}>
                    <FormattedMessage id="reviermanager.button.replace" defaultMessage="Ja, Gerät ersetzen" />
                </Button>
            ) : (
                <Button
                    color="primary"
                    variant="contained"
                    startIcon={<AddAPhotoOutlined />}
                    disabled={pristine || hasValidationErrors || submitting}
                    type="submit"
                >
                    <FormattedMessage id="reviermanager.button.check" defaultMessage="Prüfen" />
                </Button>
            )}
        </FormButtonsWrapper>
    );
};

interface Props<FormValues = AnyObject> extends FormProps<FormValues> {
    onSubmit: (values: FormValues, form: FormApi<FormValues>) => SubmissionErrors | Promise<SubmissionErrors | undefined> | undefined | void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleCancelClick: (val: any) => void;
    handleSubmitClick: () => void;
    data: boolean;
}

const ChangeDeviceForm: FC<PropsWithChildren<Props & ContentWrapperProps>> = ({
    children,
    link,
    handleCancelClick,
    data,
    handleSubmitClick,
    ...props
}) => (
    <Form
        mode="edit"
        customButtons={<FormButtons handleCancelClick={handleCancelClick} data={data} handleSubmitClick={handleSubmitClick} />}
        {...props}
    >
        {children}
    </Form>
);

export default ChangeDeviceForm;
